<template>
  <div class="content">
    <ul>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_weeks_1" name="radio_weeks" type="radio" value="week_to_date" v-model="checked" />
          <label for="radio_weeks_1" class="radio-label" @click="onChangeWeekToDate">{{ $t('week_to_date') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_weeks_2" name="radio_weeks" type="radio" value="last_week" v-model="checked" />
          <label for="radio_weeks_2" class="radio-label" @click="onChangeLastWeek">{{$t('last')}}</label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.lastWeeks" @input="onChangeLastWeek" />
          <label>{{ $t('week') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_weeks_3" name="radio_weeks" type="radio" value="form_week" v-model="checked" />
          <label for="radio_weeks_3" class="radio-label" @click="onChangeFromWeek"></label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.fromWeeks" />
          <label>{{ $t('week') }}, {{ $t('from') }}</label>
          <select name="day" class="input--tabs" v-model="fillterForm.day">
            <option v-for="day in listDay" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
          <select name="month" class="input--tabs" v-model="fillterForm.month" @change="createDayByMonth('change')">
            <option v-for="day in listMonth" :key="day.value" :value="day.value">{{ $t(day.name.toLowerCase()) }}</option>
          </select>
          <select name="day" class="input--tabs" v-model="fillterForm.year" @change="createDayByMonth('change')">
            <option v-for="day in listYear" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import listDateTime from '@/constants/dateTime'
import tabType from '@/constants/tabType'
import modeQuery from '@/constants/modeQuery'
import moment from 'moment'
import { datetime } from '@/config'

export default {
  name: 'FilterWeeks',
  data () {
    return {
      listDay: [],
      listMonth: listDateTime.month,
      listYear: listDateTime.year,
      checked: null,
      fillterForm: {
        lastWeeks: 4,
        fromWeeks: 4,
        day: new Date().getDate(),
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      },
      day: {
        createdAtMin: null,
        createdAtMax: null
      }
    }
  },
  created () {
    this.createDayByMonth('init')
  },
  methods: {
    convertMonth (month) {
      return month + 1 <= 9 ? `0${month + 1}` : month + 1
    },
    createDayByMonth (type) {
      const month = this.fillterForm.month
      const year = this.fillterForm.year
      const date = new Date(year, month, 1)
      let list = []
      while (date.getMonth() === month) {
        list = [...list, { value: new Date(date).getDate(), name: new Date(date).getDate() }]
        date.setDate(date.getDate() + 1)
      }
      this.listDay = list
      if (type === 'change') {
        this.onChangeFromWeek()
      }
    },
    onChangeWeekToDate () {
      this.checked = tabType.WEEK.WEEK_TO_DATE
      this.day = {
        createdAtMin: moment()
          .startOf(datetime.WEEK)
          .toJSON(),
        createdAtMax: moment().toJSON()
      }
      this.$emit('changeWeek', this.day, modeQuery.WEEK, 0)
    },
    onChangeLastWeek () {
      this.checked = tabType.WEEK.LAST_WEEK
      this.day = {
        createdAtMin: moment()
          .subtract(Number(this.fillterForm.lastWeeks), datetime.WEEK)
          .startOf(datetime.WEEK)
          .toJSON(),
        createdAtMax: moment()
          .endOf(datetime.WEEK)
          .toJSON()
      }
      this.$emit('changeWeek', this.day, modeQuery.WEEK, Number(this.fillterForm.lastWeeks))
    },
    onChangeFromWeek () {
      this.checked = tabType.WEEK.FORM_WEEK
      const date = new Date(`${this.fillterForm.year}-${this.convertMonth(this.fillterForm.month)}-${this.fillterForm.day}`)
      this.day = {
        createdAtMin: moment(date)
          .startOf(datetime.WEEK)
          .toJSON(),
        createdAtMax: moment(date)
          .add(Number(this.fillterForm.fromWeeks), datetime.WEEK)
          .endOf(datetime.WEEK)
          .toJSON()
      }
      this.$emit(
        'changeWeek',
        this.day,
        modeQuery.WEEK,
        Number(this.fillterForm.fromWeeks),
        moment()
          .endOf(datetime.WEEK)
          .unix(),
        moment(this.day.createdAtMax)
          .endOf(datetime.WEEK)
          .unix()
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  .radio-btn {
    padding-bottom: 10px;
    margin: 0.5rem;
    display: flex;
    align-items: center;
    align-content: center;
  }
  .radio {
    display: flex;
    align-items: baseline;
  }
  label {
    color: #a0a8b4;
  }
  .input--tabs {
    margin: 0 8px;
    height: 32px;
    background-image: none;
    border: 1px solid #ccc;
    width: 70px;
    outline: none;
  }
}
</style>
